const KEY = "oxo_recent_searches";

export function getRecent() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function addRecent(term) {
  const t = (term || "").trim();
  if (t.length < 2) return;
  let list = getRecent().filter((x) => x.toLowerCase() !== t.toLowerCase());
  list.unshift(t);
  list = list.slice(0, 6);
  localStorage.setItem(KEY, JSON.stringify(list));
}

export function removeRecent(term) {
  const list = getRecent().filter((x) => x.toLowerCase() !== (term || "").toLowerCase());
  localStorage.setItem(KEY, JSON.stringify(list));
}

export function clearRecent() {
  localStorage.removeItem(KEY);
}
